var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.backtop > 0),expression:"backtop > 0"}],staticClass:"return-top",on:{"click":function($event){return _vm.backToTop()}}},[_c('Icon',{staticClass:"return-top-icon",attrs:{"type":"ios-arrow-up"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }